import React from 'react';
import { useFormContext } from '../../../context/FormContext';
import { Input } from '../../ui/Input';

export const DistributionSection = () => {
  const { data, updateFormSection } = useFormContext();
  const dist = data.form.distribution;

  const updateField = (year, value) => {
    updateFormSection('distribution', dist.map(d => d.year === year ? { ...d, percentage: value } : d));
  };

  const total = dist.reduce((sum, d) => sum + (Number(d.percentage) || 0), 0);
  const isError = total > 0 && total !== 100;

  return (
    <div>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 mb-6">
        {dist.map(d => (
          <Input 
            key={d.year}
            label={d.year} 
            type="number" 
            placeholder="%"
            value={d.percentage} 
            onChange={e => updateField(d.year, e.target.value)} 
          />
        ))}
      </div>
      
      <div className={`p-4 rounded-lg flex items-center justify-between font-medium text-sm ${isError ? 'bg-red-50 text-red-600 border border-red-200' : 'bg-brand-light/50 text-brand-text border border-brand-border'}`}>
        <span>Total Distribution</span>
        <span className="font-bold">{total}%</span>
      </div>
      {isError && <p className="text-xs text-red-500 mt-2">Distribution must equal exactly 100%.</p>}
    </div>
  );
};